module.exports = __webpack_public_path__ + "img/nt115-01-81-1.prt.ee05f46a.jpg";